import PropTypes from 'prop-types'
import React from 'react'

import Button from 'components/PreClass/Checklist/components/common/Button'

import { CtaSection, CtaBtns, BtnWithSubText, SubText } from './styles'
import useVideoConnect from './useVideoConnect'

const CtaComponent = ({ isRecording }) => {
    const buttons = useVideoConnect()
    return (
        <CtaSection applyMarginTop={!isRecording}>
            <CtaBtns>
                {buttons.map(button => {
                    return (
                        <BtnWithSubText key={button.id}>
                            <Button {...button} />
                            <SubText>{button.subtext}</SubText>
                        </BtnWithSubText>
                    )
                })}
            </CtaBtns>
        </CtaSection>
    )
}

CtaComponent.propTypes = {
    isRecording: PropTypes.bool.isRequired,
    classTitle: PropTypes.string.isRequired,
}

export default CtaComponent
